import Vue from 'vue'
import VueRouter from 'vue-router'
import About from '@/views/About.vue'
import NotFound from '@/views/NotFound'
import Top from '@/views/Top'
import New from '@/views/New'
import Ask from '@/views/Ask'
import Show from '@/views/Show'
import Job from '@/views/Job'
import ViewPost from '@/views/ViewPost'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Root',
    redirect: '/top'
  },
  {
    path: '/top',
    name: 'Top',
    component: Top
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/new',
    name: 'New',
    component: New
  },
  {
    path: '/ask',
    name: 'Ask',
    component: Ask
  },
  {
    path: '/show',
    name: 'Show',
    component: Show
  },
  {
    path: '/job',
    name: 'Job',
    component: Job
  },
  {
    path: '/post/:id',
    name: 'ViewPost',
    component: ViewPost
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
